import React from "react";
import Tooltip from "@mui/material/Tooltip";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {
  getOverlappingOtherStoreShifts,
  otherStoreShiftLabel,
  sortOtherStoreShifts,
} from "./otherStoreShifts";

// Rides on a shift card here when the person also works at another store that
// day, so scheduling them here does not hide the other shift. Turns red when
// the two share time, and the tooltip lists every other-store shift. It is an
// icon rather than a label because a label covers a shift time on a minimized
// card or a card split into one bar per shift. Sits bottom-right, left of the
// warning icon, where the bars leave empty space after the times. The card
// renders it among its own icons, so clicks and drags on it reach the card.
// Its offsets follow the warning icon's, which sits lower in minimize mode.
function OtherStoreShiftMarker({
  ownShifts,
  otherStoreShifts,
  getTime,
  minimizeMode,
}) {
  const shifts = sortOtherStoreShifts(otherStoreShifts);
  if (shifts.length === 0) return null;

  const hasOverlap =
    getOverlappingOtherStoreShifts(ownShifts, shifts).length > 0;

  return (
    <div
      className={`absolute z-20 ${
        minimizeMode ? "bottom-0 right-4" : "bottom-1 right-5"
      }`}
    >
      <Tooltip
        title={
          <div>
            <p>
              {hasOverlap
                ? "Overlaps a shift at another store"
                : "Also works at another store"}
            </p>
            <ul className="list-disc pl-4">
              {shifts.map((shift, i) => (
                <li key={i}>{otherStoreShiftLabel(shift, getTime)}</li>
              ))}
            </ul>
          </div>
        }
      >
        <StorefrontIcon
          sx={{ fontSize: "10px" }}
          className={hasOverlap ? "text-red-200" : "text-white"}
        />
      </Tooltip>
    </div>
  );
}

export default OtherStoreShiftMarker;
